export default __webpack_public_path__ + "static/media/in4.5d961e06.jpg";